import { render, staticRenderFns } from "./CheckedInfoWrap.vue?vue&type=template&id=64eb20e5&scoped=true&"
import script from "./CheckedInfoWrap.vue?vue&type=script&lang=js&"
export * from "./CheckedInfoWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb20e5",
  null
  
)

export default component.exports